import React from "react";
import InfoCard from "./InfoCard";
import clock from "../../assets/icons/clock.svg";
import location from "../../assets/icons/marker.svg";
import phone from "../../assets/icons/phone.svg";

const Info = () => {
  return (
    <div className="mt-20">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 ">
        <InfoCard
          cardTitle="Opening Hours"
          bgClass="bg-gradient-to-r from-secondary to-primary"
          img={clock}
        />
        <InfoCard
          cardTitle="Visit our location"
          bgClass="bg-accent"
          img={location}
        />
        <InfoCard
          cardTitle="Contact us now"
          bgClass="bg-gradient-to-r from-secondary to-primary"
          img={phone}
        />
      </div>
    </div>
  );
};

export default Info;
